import { Box, Button, styled, TableCell, Typography } from "@mui/material";

const GreenButton = styled(Button)(() => ({
    fontSize: '20px',
    color: '#FFFFFF',
    backgroundColor: '#01CFBE',
    borderRadius: '100rem',
    height: '40px',
    lineHeight: '40px',
}));

const WhiteButton = styled(Button)(() => ({
    fontSize: '20px',
    color: '#01CFBE',
    backgroundColor: '#FFFFFF',
    borderColor: '#01CFBE',
    borderRadius: '100rem',
    height: '40px',
    lineHeight: '40px',
}));

const ItemLabelBox = styled(Box)(() => ({
    backgroundColor: '#555555',
    width: '100%',
    height: '40px',
}));

const ItemLabelTypography = styled(Typography)(() => ({
    fontSize: '17px',
    color: '#FFFFFF',
    height: '40px',
    lineHeight: '40px',
}));

const ConditionalTableHeadCell = styled(TableCell)(() => ({
    color: '#a7a4a4ff',
    borderBottom: 'none',
    align: 'left',
    padding: '10px 10px',
}));

const ConditionalTableBodyCell = styled(TableCell)(() => ({
    fontSize: '18px',
    borderBottom: '1px solid #a7a4a4ff',
    align: 'left',
    padding: '5px 10px',
}));

export { GreenButton, WhiteButton, ItemLabelBox, ItemLabelTypography, ConditionalTableHeadCell, ConditionalTableBodyCell }
